import api from './apiClient';

// Beacon relative URL kullanır: apiClient ile aynı origin'e gider ve oturum
// cookie'si otomatik eklenir. Mutlak URL (REACT_APP_API_URL) kullanıldığında
// istek cross-origin oluyordu; sendBeacon CORS preflight yapamadığı için
// oturum kapanış isteği hiç gönderilmiyordu.
const SESSION_END_URL = '/api/Log/session/end';

export const startSession = async (powerBiReportId) => {
  const response = await api.post('/Log/session/start', { powerBiReportId });
  return response.data.sessionId;
};

/**
 * Oturumu kapatır. Son sayfanın logu da aynı istekte gönderilir — böylece
 * kullanıcı rapor içinde hiç sayfa değiştirmeden çıksa bile ilk sayfa kaydedilir.
 *
 * @param {object} payload
 * @param {number} payload.sessionId
 * @param {number} payload.durationSeconds
 * @param {string} [payload.lastPageName]
 * @param {number} [payload.lastPageDurationSeconds]
 * @param {string} [payload.endReason] switch | logout | navigate | envswitch | unload
 */
export const endSession = async (payload) => {
  await api.post('/Log/session/end', payload);
};

/**
 * Heartbeat — aynı endpoint, `endReason` GÖNDERİLMEDEN. Sunucu oturumu açık
 * bırakır, yalnızca SessionEnd/DurationSeconds'ı ilerletir.
 *
 * Amacı tek bir senaryo: tarayıcı penceresi X ile kapatıldığında Chrome süreci
 * sonlandırıp kuyruktaki beacon'ı iptal ediyor; ne visibilitychange ne pagehide
 * ne de keepalive fetch bunu kurtarabiliyor. Heartbeat sayesinde oturum, son
 * heartbeat anıyla kapanmış olarak kalır.
 */
export const heartbeatSession = async (payload) => {
  await api.post('/Log/session/end', payload);
};

/**
 * Oturumu sayfa kapanışı sırasında kapatır. Normal XHR bu noktada iptal
 * edileceği için sendBeacon (yoksa keepalive fetch) kullanılır.
 * Aynı payload'ı alır; ateşle-unut, hata döndürmez.
 */
export const endSessionBeacon = (payload) => {
  const body = JSON.stringify(payload);

  if (navigator.sendBeacon) {
    const queued = navigator.sendBeacon(
      SESSION_END_URL,
      new Blob([body], { type: 'application/json' })
    );
    if (queued) return;
    console.warn('Oturum kapanış beacon\'ı kuyruğa alınamadı — fetch ile deneniyor.');
  }

  // Fallback: sendBeacon yok veya kuyruk doldu.
  fetch(SESSION_END_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
    credentials: 'include',
    keepalive: true,
  }).catch((e) => console.warn('Oturum kapanış isteği gönderilemedi:', e));
};

export const logPage = async (sessionId, pageName, durationSeconds) => {
  await api.post('/Log/page', { sessionId, pageName, durationSeconds });
};
